class UnsubscribeO2dSentButtonComponent {
  constructor(Orders, toastr, Notifications) {
    Object.assign(this, {
      Orders,
      toastr,
      Notifications,
      BODACDC_4235: FEATURE_BODACDC_4235,
      unsubscribing: false,
      unsubscribed: false,
    });
  }

  unsubscribe() {
    this.unsubscribing = true;
    this.Orders.unsubscribeFromO2dSent(this.dispenseOrderId, this.orderId)
      .then(({}) => {
        this.unsubscribed = true;
      })
      .catch((err) => {
        if (this.BODACDC_4235) {
          const message = err.status === 403 ? this.Notifications.rxHub.unauthorised : err.message || this.Notifications.generic.failure;
          this.toastr.error(message);
        } else {
          this.toastr.error(err.message);
        }
      })
      .finally(() => {
        this.unsubscribing = false;
      });
  }
}

UnsubscribeO2dSentButtonComponent.$inject = ['Orders', 'toastr', 'Notifications'];
angular.module('pims').component('unsubscribeO2dSentButton', {
  templateUrl: 'app/views/visits/list/tabs/rx-hub/components/unsubscribe-o2d-sent/unsubscribe-o2d-sent-button.component.html',
  controller: UnsubscribeO2dSentButtonComponent,
  controllerAs: 'vm',
  bindings: {
    dispenseOrderId: '=',
    orderId: '=',
  }
});
